import {useMediaQuery} from '@logistics-frontend/blocks/legacy'
import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {useI18n} from '@logistics-frontend/core/i18n'
import {useCallback, useEffect, useState} from 'react'

import {useInputAddress as useAddress} from 'src/components/map-bounds'
import {useNotificationCallback} from 'src/components/notifications'
import {useConfig} from 'src/config'

import {getGeolocationFromBrowser} from './utils'

const FIRST_ADDRESS_INDEX = 0

export const useGeolocationErrorNotification = (error?: string) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const notification = useNotificationCallback()
  useEffect(() => {
    if (!!error && isMobile) {
      return notification({message: error, type: 'alert', severity: 'warning'})
    }
  }, [notification, error, isMobile])
}

type GeolocationField = [{error: string; loading: boolean}, {updateGeolocation: () => void}]
export const useUpdateGeolocation = (): GeolocationField => {
  const t = useI18n()
  const [, {setValue}] = useAddress(FIRST_ADDRESS_INDEX)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const {zonePoint} = useConfig().initialProps
  const ERROR_MESSAGE = t('order.geolocation_error', 'Нет доступа к\u00a0геолокации')

  const updateGeolocation = useCallback(() => {
    if (loading) {
      return
    }
    setLoading(true)
    getGeolocationFromBrowser(coords => {
      if (!coords) {
        setError(ERROR_MESSAGE)
      }
      setValue(coords || zonePoint)
      setLoading(false)
    })
  }, [loading, setValue, zonePoint, ERROR_MESSAGE])

  return [{error, loading}, {updateGeolocation}]
}
